fragment FileFragment on EntityAttributeValueFile {
    fileId
    name
    href
    viewHref
    viewableInBrowser
    fileType
    uploadedTime
    creatorUser {
        id
        name
        avatarUrl
        initials
    }
}
